import React, { useState, useEffect, useCallback } from 'react';
import socketService from '../services/socketService';
import Layout from '../components/Layout';
import moment from 'moment-timezone';

const SMSManager = () => {
    
    const [formData, setFormData] = useState({
        username: '',
        sender_id: '',
        message: '',
        simno: '',
        operator: '',
        device_name: '',
        received_at: moment().tz('Asia/Dhaka').format('YYYY-MM-DDTHH:mm')
    });

    const [loading, setLoading] = useState(false);

    // ফরম্যাট টেমপ্লেট
    const formatTemplates = {
        nagad: "Cash Out | Amount: 55 Tk., A/C : 015****5460 TxnID: 74ROTTEG",
        bkash: "Cash Out | Amount: ৳90.00 number: 0196XXXX346 TxnID: DA30P3I2O8"
    };

    // রেসপন্স হ্যান্ডলার
    const handleSmsResponse = useCallback((response) => {
        console.log("SERVER RESPONSE:", response);
        setLoading(false);
        
        if (response.success) {
            alert(response.message || '✅ App Log Added Successfully');
            // ফর্ম রিসেট
            setFormData(prev => ({
                ...prev,
                message: '',
                received_at: moment().tz('Asia/Dhaka').format('YYYY-MM-DDTHH:mm')
            }));
        } else {
            alert(response.message || '❌ Failed to add Log');
        }
    }, []);

    // সকেট কানেকশন
    useEffect(() => {
        socketService.connect();
        // রেসপন্স ইভেন্ট যদি একই থাকে তবে এটিই থাকবে, আর যদি অ্যাপ লগের জন্য আলাদা ইভেন্ট থাকে তবে সেটি এখানে দিবেন
        socketService.on('sms_log_response', handleSmsResponse);

        return () => {
            socketService.off('sms_log_response', handleSmsResponse);
        };
    }, [handleSmsResponse]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    // টেমপ্লেট সেট করার ফাংশন
    const setTemplate = (type) => {
        let senderName = '';
        
        if (type === 'nagad') {
            senderName = 'NAGAD'; // 🔥 Nagad এর জন্য বড় হাতের 'NAGAD'
        } else if (type === 'bkash') {
            senderName = 'bKash'; // bKash এর জন্য 'bKash'
        }

        setFormData(prev => ({
            ...prev,
            message: formatTemplates[type],
            sender_id: senderName 
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        
        if (!formData.username || !formData.message || !formData.sender_id) {
            alert('⚠️ Please fill required fields (Username, Sender ID, Message)');
            return;
        }

        setLoading(true);

        const payload = {
            username: formData.username,
            senderID: formData.sender_id,
            message: formData.message,
            simno: formData.simno || "Manual-App",
            operator: formData.operator || "N/A",
            deviceName: formData.device_name || "Admin Panel",
            receivedAt: formData.received_at,
            seenBy: "unseen" // App Log এর জন্য অটোমেটিক unseen
        };

        // শুধুমাত্র App Log এর ইভেন্ট কল হবে
        socketService.emit('add_manual_alternative_log', payload);
    };

    return (
        <Layout title="Add App Log | Dabit Pay">
            <div className="content">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h4 className="text-primary mb-0">📱 Add Manual App Log</h4>
                </div>

                <div className="card shadow-sm border-0">
                    <div className="card-body">
                        
                        {/* টেমপ্লেট বাটন (এখন সবসময় দেখাবে) */}
                        <div className="alert alert-info d-flex gap-2 align-items-center mb-4">
                            <small className="fw-bold me-2">Quick Templates:</small>
                            <button type="button" className="btn btn-sm btn-outline-danger" onClick={() => setTemplate('nagad')}>
                                Nagad Format
                            </button>
                            <button type="button" className="btn btn-sm btn-outline-pink" style={{color: '#e2136e', borderColor: '#e2136e'}} onClick={() => setTemplate('bkash')}>
                                bKash Format
                            </button>
                        </div>

                        <form onSubmit={handleSubmit} className="row g-3">
                            <div className="col-md-3">
                                <label className="form-label fw-semibold">Username <span className="text-danger">*</span></label>
                                <input type="text" name="username" className="form-control" placeholder="Enter username" value={formData.username} onChange={handleChange} required />
                            </div>
                            
                            <div className="col-md-3">
                                <label className="form-label fw-semibold">Sender ID <span className="text-danger">*</span></label>
                                <input type="text" name="sender_id" className="form-control" placeholder="bKash / NAGAD" value={formData.sender_id} onChange={handleChange} required />
                            </div>
                            
                            <div className="col-md-6">
                                <label className="form-label fw-semibold">Full Message <span className="text-danger">*</span></label>
                                <textarea name="message" className="form-control" rows="3" placeholder="Paste full Notification/App content..." value={formData.message} onChange={handleChange} required />
                            </div>
                            
                            {/* Seen By ইনপুট রিমুভ করা হয়েছে কারণ App Log এ এটি দরকার নেই */}

                            <div className="col-md-4">
                                <label className="form-label fw-semibold">Source / SIM Info</label>
                                <input type="text" name="simno" className="form-control" value={formData.simno} onChange={handleChange} placeholder="Auto: Manual-App" />
                            </div>

                            <div className="col-md-4">
                                <label className="form-label fw-semibold">Operator</label>
                                <input type="text" name="operator" className="form-control" value={formData.operator} onChange={handleChange} />
                            </div>

                            <div className="col-md-4">
                                <label className="form-label fw-semibold">Device</label>
                                <input type="text" name="device_name" className="form-control" value={formData.device_name} onChange={handleChange} />
                            </div>

                            <div className="col-md-4">
                                <label className="form-label fw-semibold">Received At</label>
                                <input type="datetime-local" name="received_at" className="form-control" value={formData.received_at} onChange={handleChange} required />
                            </div>

                            <div className="col-md-12 text-end mt-4">
                                <button type="submit" className="btn btn-primary px-5 py-2" disabled={loading}>
                                    {loading ? (
                                        <><i className="fa fa-spinner fa-spin me-2"></i>Processing...</>
                                    ) : (
                                        <>
                                            <i className="fa fa-paper-plane me-2"></i>
                                            Add App Log
                                        </>
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default SMSManager;